import { render } from "./TablaProfesionalesAsignados.vue?vue&type=template&id=0fdb52be&ts=true"
import script from "./TablaProfesionalesAsignados.vue?vue&type=script&lang=ts"
export * from "./TablaProfesionalesAsignados.vue?vue&type=script&lang=ts"

import "./TablaProfesionalesAsignados.vue?vue&type=style&index=0&id=0fdb52be&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__